import { render, staticRenderFns } from "./SectionOpen.vue?vue&type=template&id=489b0148&"
import script from "./SectionOpen.vue?vue&type=script&lang=js&"
export * from "./SectionOpen.vue?vue&type=script&lang=js&"
import style0 from "./SectionOpen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports